module.exports = __webpack_public_path__ + "static/media/lds-logo_lv.2858234b.svg";